import React, { Component } from 'react'
import { Line } from 'rc-progress'

import Controls from './controls'
import FooterAudio from './FooterAudio'

import { Button, MaterialIcon } from 'controls'
import { colors } from 'theme'

import styles from './styles'

export default class PlayAudio extends Component {
  constructor(props) {
    super(props)

    const {
      classcomponents: {
        PlayButton,
        PauseButton,
        MinusTimeButton,
        AddTimeButton,
        PlusVolumeButton,
        MinusVolumeButton
      },
      events
    } = props

    this.playButton = (
      <Button size="tiny" color="primary" onClick={events.onPlay}>
        Play
      </Button>
    )
    this.pauseButton = (
      <Button size="tiny" color="primary" onClick={events.onPause}>
        Pause
      </Button>
    )
    this.addTimeButton = (
      <Button size="tiny" color="primary" onClick={this.addTime}>
        {'>>'}
      </Button>
    )
    this.minusTimeButton = (
      <Button size="tiny" color="primary" onClick={this.minusTime}>
        {'<<'}
      </Button>
    )

    this.plusVolumeButton = (
      <Button size="tiny" color="primary" onClick={this.handlePlusVolume}>
        <MaterialIcon icon="add" size="small" />
      </Button>
    )
    this.minusVolumeButton = (
      <Button size="tiny" color="primary" onClick={this.handleMinusVolume}>
        <MaterialIcon icon="remove" size="small" />
      </Button>
    )

    if (PlayButton) {
      this.playButton = <PlayButton onClick={events.onPlay} />
    }
    if (PauseButton) {
      this.pauseButton = <PauseButton onClick={events.onPause} />
    }
    if (AddTimeButton) {
      this.addTimeButton = <AddTimeButton onClick={this.addTime} />
    }
    if (MinusTimeButton) {
      this.minusTimeButton = <MinusTimeButton onClick={this.minusTime} />
    }
    if (PlusVolumeButton) {
      this.plusVolumeButton = (
        <PlusVolumeButton onClick={this.handlePlusVolume} />
      )
    }
    if (MinusVolumeButton) {
      this.minusVolumeButton = (
        <MinusVolumeButton onClick={this.handlePlusVolume} />
      )
    }

    this.state = {
      audioDuration: 0,
      audioCurrentTime: 0
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, props) {
    nextProps.isPlay ? this.audio.play() : this.audio.pause()
  }

  handleLoadedMetadata = event => {
    const { events } = this.props
    this.video = event.target
    this.setState({
      audioDuration: this.video.duration
    })

    events.onLoadedMetadata && events.onLoadedMetadata(event)
  }

  handleTimeUpdate = event => {
    this.setState({
      audioCurrentTime: this.audio.currentTime
    })
  }

  handlePlusVolume = () => {
    const volume = this.audio.volume
    volume >= 0.9 ? (this.audio.volume = 1) : (this.audio.volume += 0.1)
  }

  handleMinusVolume = () => {
    const volume = this.audio.volume
    volume <= 0.1 ? (this.audio.volume = 0) : (this.audio.volume -= 0.1)
  }

  addTime = () => {
    const { stepsTime = 1 } = this.props.config
    this.audio.currentTime += stepsTime
  }

  minusTime = () => {
    const { stepsTime = 1 } = this.props.config
    this.audio.currentTime -= stepsTime
  }

  render() {
    const {
      audio,
      isPlay,
      progress,
      events: {
        handleOnWaiting = () => {},
        handleOnSeeked = () => {},
        handleOnSeeking = () => {}
      },
      config: { hiddeDownloadInMobile },
      ...rest
    } = this.props
    const { audioDuration, audioCurrentTime } = this.state
    return (
      <div className="wrapper-play-audio">
        <Controls
          isPlay={isPlay}
          playButton={this.playButton}
          pauseButton={this.pauseButton}
          minusTimeButton={this.minusTimeButton}
          addTimeButton={this.addTimeButton}
          plusVolumeButton={this.plusVolumeButton}
          minusVolumeButton={this.minusVolumeButton}
        />

        <Line
          className="progress"
          percent={(audioCurrentTime / audioDuration).toFixed(2) * 100}
          {...progress}
        />

        <FooterAudio
          audio={audio}
          audioCurrentTime={audioCurrentTime}
          audioDuration={audioDuration}
          hiddeDownloadInMobile={hiddeDownloadInMobile}
        />

        <audio
          src={audio.url}
          ref={el => (this.audio = el)}
          onSeeked={handleOnSeeked}
          onSeeking={handleOnSeeking}
          onTimeUpdate={this.handleTimeUpdate}
          onWaiting={handleOnWaiting}
          onLoadedMetadata={this.handleLoadedMetadata}
          {...rest}
        />
        <style jsx>{styles}</style>
      </div>
    )
  }
}

PlayAudio.defaultProps = {
  isPlay: false,
  audio: {
    name: 'Despacito',
    url:
      'https://p.scdn.co/mp3-preview/076f200df2b0f8b361ca1e6c268dba878ad998ce?cid=555776939cf64ea6b39915cf4d5d875d'
  },
  events: {
    onPlay: () => {},
    onPause: () => {},
    onLoadedMetadata: event => {},
    handleOnWaiting: event => console.log('onWaiting'),
    handleOnSeeked: event => console.log('Cargado'),
    handleOnSeeking: event => console.log('Cardando...')
  },
  progress: {
    strokeWidth: 2,
    trailWidth: 2,
    strokeColor: colors.primary,
    trailColor: colors.lightGray
  },
  config: {
    stepsTime: 1, // in seconds
    hiddeDownloadInMobile: false
  },
  classcomponents: {
    // Class or functions
    // Example: PlayButton: (props)=> <Button size="tiny" color="primary" {...props}>Example</Button>
  }
}
